import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminCampaignsKeys } from "Api/Queries/Admin/useAdminCampaignsQuery";
import {
  type CampaignImageType,
  apiPut,
  getApiUrl,
  putAdminCampaignsIdImagesImageTypePath,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  campaignId: number;
  imageType: CampaignImageType;
  file: File;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useUploadCampaignImageMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      async ({ campaignId, imageType, file }: Parameters) => {
        const path = putAdminCampaignsIdImagesImageTypePath(
          campaignId,
          imageType,
        );
        const form = new FormData();
        form.append("file", file);

        return apiPut(`${getApiUrl()}${path}`, form, undefined);
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminCampaignsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
